export class BaseCache {
  cache: Cache | null = null
  cacheName: string

  constructor(cacheName: string) {
    this.cacheName = cacheName
  }

  async init() {
    if ("caches" in window) {
      this.cache = await caches.open(this.cacheName)
    }
  }
}
